(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-item-info.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-item-info.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Image
} = svs.content.image_v2;
const OverviewItemInfo = _ref => {
  let {
    ticketName,
    ticketPrice,
    ticketImg,
    voucherCode = '',
    isRedeemed,
    onClick
  } = _ref;
  const handleClick = e => {
    e && e.preventDefault();
    return !isRedeemed && onClick(voucherCode);
  };
  return React.createElement("div", {
    className: "padding-1 ".concat(isRedeemed && 'redeemed' || '', " info-container"),
    onClick: handleClick
  }, React.createElement("div", {
    className: "info-wrapper"
  }, React.createElement("div", {
    className: "ticket-img"
  }, ticketImg && React.createElement(Image, {
    image: _objectSpread(_objectSpread({}, ticketImg), {}, {
      sizes: '(min-width: 320px) 320px, 100vw'
    })
  })), React.createElement("div", null, React.createElement("div", {
    className: "flex-row"
  }, React.createElement("div", {
    className: "f-bold",
    "data-testid": "ticketName"
  }, ticketName)), React.createElement("div", {
    className: "flex-row"
  }, React.createElement("div", null, "Pris:"), React.createElement("div", {
    "data-testid": "ticketPrice"
  }, ticketPrice && "".concat(svs.utils.format.Currency(ticketPrice), " kr") || '')), React.createElement("div", {
    className: "flex-row"
  }, React.createElement("div", null, "Presentkod:"), React.createElement("div", {
    "data-testid": "voucherCode"
  }, voucherCode.toUpperCase())))), React.createElement("span", {
    className: "info-redeemed",
    "data-testid": "isRedeemed"
  }, isRedeemed ? 'Inlöst' : 'Oinlöst'));
};
setGlobal('svs.ticket_gifts.redeem.components.OverviewItemInfo', OverviewItemInfo);

 })(window);